import {FormControl, FormControlLabel, FormLabel, Radio, RadioGroup} from '@material-ui/core';
import React from 'react';
import {useDispatch} from 'react-redux';
import ValidatableEmailInput from 'Shared/components/ValidatableEmailInput';
import ValidatablePhoneInput from 'Shared/components/ValidatablePhoneInput';
import ValidatableTextInput from 'Shared/components/ValidatableTextInput';
import {
  changeAccountType,
  validateEmail,
  validateFirstName,
  validateLastName,
  validatePhoneNumber,
  validateUserName,
} from 'Users/ducks/userEntry';
import {
  AccountType,
  BasicInformation,
  EmptyBasicInformation,
  isExternalBasicInformation,
} from 'Users/models/User/BasicInformation';
import './BasicUserInformationEntry.sass';

type BasicUserInformationEntryProps = {
  basicUserInformation: BasicInformation;
  isEdit?: boolean;
};

const BasicUserInformationEntry = (props: BasicUserInformationEntryProps) => {
  const {firstName, lastName, email, accountType} = props.basicUserInformation;
  const {isEdit} = props;
  const dispatch = useDispatch();

  return (
    <>
      <div className="basic-user-information-section">
        <FormControl component="fieldset" disabled={isEdit} className="basic-user-information-section__radio-group">
          <FormLabel component="legend" className="basic-user-information-section__radio-group-label">
            Account Type
          </FormLabel>
          <RadioGroup
            row
            name="user-type"
            value={accountType}
            onChange={e => dispatch(changeAccountType(e.target.value as AccountType))}
          >
            <FormControlLabel
              control={<Radio checked={accountType === 'Internal'} color="primary" />}
              label={
                <span>
                  Internal
                  <br />
                  <span className="basic-user-information-section__login-method-description">
                    This user has an Allstate NTID and will immediately be able to login to MyAccess when the user is
                    created.
                  </span>
                </span>
              }
              value="Internal"
              className="basic-user-information-section__radio-label"
            />
            {/* <FormControlLabel
              control={<Radio checked={accountType === 'External'} color="primary" />}
              label={
                <span>
                  External
                  <br />
                  <span className="basic-user-information-section__login-method-description">
                    This user does not have an Allstate NTID and will be sent an invitation via email to create a
                    MyAccess account.
                  </span>
                </span>
              }
              value="External"
              className="basic-user-information-section__radio-label"
            /> */}
          </RadioGroup>
        </FormControl>
        <p className="basic-user-information-section__header">Basic User Information</p>
        <p className="basic-user-information-section__description">
          Please supply the user's name and contact information below.
        </p>
        <ValidatableTextInput
          label="First Name"
          className="basic-user-information-section__field"
          onValidate={firstName => dispatch(validateFirstName(firstName))}
          value={firstName || EmptyBasicInformation.firstName}
        />
        <ValidatableTextInput
          label="Last Name"
          className="basic-user-information-section__field"
          onValidate={lastName => dispatch(validateLastName(lastName))}
          value={lastName || EmptyBasicInformation.lastName}
        />
        <ValidatableEmailInput
          label="Email"
          className="basic-user-information-section__field"
          onValidate={email => dispatch(validateEmail(email))}
          value={email}
        />
        {(!isExternalBasicInformation(props.basicUserInformation) || isEdit) && (
          <>
            <ValidatableTextInput
              label="Username"
              className="basic-user-information-section__field"
              onValidate={username => dispatch(validateUserName(username))}
              value={props.basicUserInformation.username || EmptyBasicInformation.username}
              disabled={isEdit}
            />
            <ValidatablePhoneInput
              label="Phone Number"
              className="basic-user-information-section__field"
              onValidate={phone => dispatch(validatePhoneNumber(phone))}
              value={props.basicUserInformation.phoneNumber || EmptyBasicInformation.phoneNumber}
            />
          </>
        )}
      </div>
    </>
  );
};

export default BasicUserInformationEntry;
